import { Routes } from '@angular/router';
//import { Login } from './components/login/login';
//import { FileNoticed } from './components/file-noticed/file-noticed';
import { FileNotNoticed } from './components/file-not-noticed/file-not-noticed';
import { Complete } from './components/complete/complete';
import { ProcessLink } from './components/processlink/processlink';
import { Home } from './components/home/home';
import { Contact } from './components/contact/contact';
import { CourtDocuments } from './components/court-documents/court-documents';
import { NavMenu } from './components/nav-menu/nav-menu';
import { KeyContacts } from './components/key-contacts/key-contacts';
import { Faqs } from './components/faqs/faqs';
import { AlreadyFiled } from './components/already-filed/already-filed';


export const routes: Routes = [
  /* { path: '', pathMatch: 'full', redirectTo: 'login' },*/
  { path: '', component: Home, pathMatch: 'full' },
  /*{ path: '', pathMatch: 'full', redirectTo: 'home' },*/
  /*{ path: 'login', component: Login },*/
  { path: 'contact', component: Contact },
  { path: 'home', component: Home },
  { path: 'court-documents', component: CourtDocuments },
  /*{ path: 'file-noticed', component: FileNoticed },*/
  { path: 'file-not-noticed', component: FileNotNoticed },
  { path: 'complete', component: Complete },
  { path: 'processlink', component: ProcessLink },
  { path: 'key-contacts', component: KeyContacts },
  { path: 'faqs', component: Faqs },
  { path: 'already-filed', component: AlreadyFiled },

  // { path: '**', redirectTo: 'login' },

];
